import React, { useState } from 'react';
import { fetchJson } from '../utils/api';
import Button from './ui/Button';

function TeamView({ teams = [], onTeamsChanged }) {
    // Wenn kein Team ausgewählt ist => "Anlegen"-Modus
    // Wenn selectedTeam != null => "Bearbeiten"-Modus
    const [selectedTeam, setSelectedTeam] = useState(null);

    // Das Formular kann beides: anlegen oder bearbeiten
    // Standardwerte für "Neues Team anlegen"
    const [formData, setFormData] = useState({
        name: '',
        punkte: 0,
    });

    // Falls wir den Bearbeiten-Vorgang abbrechen / erfolgreich speichern
    const resetForm = () => {
        setSelectedTeam(null);
        setFormData({ name: '', punkte: 0 });
    };

    // Eingabefeld-Änderungen (gilt für beide Modi)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Auf "Anlegen / Speichern" geklickt:
    const handleFormSubmit = () => {
        if (!selectedTeam) {
            // ----------- A) ANLEGEN -----------
            if (!formData.name.trim()) {
                return alert('Teamname darf nicht leer sein!');
            }
            fetchJson('/api/teams/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.name,
                    punkte: Number(formData.punkte),
                }),
            })
                .then(() => {
                    onTeamsChanged();
                    resetForm();
                })
                .catch((err) => console.error(err));
        } else {
            // ----------- B) BEARBEITEN -----------
            // Falls Team "Moderator"? => wir verstecken Namensänderung
            // Hier behalten wir den Name (wenn Moderator)
            const finalName =
                selectedTeam.name.toLowerCase() === 'moderator'
                    ? selectedTeam.name
                    : formData.name;

            fetchJson(`/api/teams/${selectedTeam.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: finalName,
                    punkte: Number(formData.punkte),
                }),
            })
                .then(() => {
                    onTeamsChanged();
                    resetForm();
                })
                .catch((err) => console.error('Fehler beim Speichern des Teams:', err));
        }
    };

    // Team löschen (nur im Bearbeiten-Modus erlaubt)
    const handleDelete = () => {
        if (!selectedTeam) return;
        fetchJson(`/api/teams/${selectedTeam.id}`, {
            method: 'DELETE',
        })
            .then(() => {
                onTeamsChanged();
                resetForm();
            })
            .catch((err) => console.error('Fehler beim Löschen des Teams:', err));
    };

    // Beim Klick auf "Bearbeiten" in der Liste => Modus "Edit"
    const startEdit = (team) => {
        setSelectedTeam(team);
        setFormData({ name: team.name, punkte: team.punkte });
    };

    return (
        <div style={{ marginLeft: '20px' }}>
            <h4>Teams verwalten</h4>

            {/* Liste der vorhandenen Teams */}
            <ul>
                {teams.map((team) => (
                    <li key={team.id}>
                        {team.name} (Punkte: {team.punkte})
                        <Button
                            size="sm"
                            onClick={() => startEdit(team)}
                            style={{ marginLeft: '10px' }}
                        >
                            Bearbeiten
                        </Button>
                    </li>
                ))}
            </ul>

            {/* EINZIGES FORMULAR: Zeigt "Neues Team erstellen" oder "Team bearbeiten" */}
            <div
                style={{
                    marginTop: '20px',
                    border: '1px solid #ccc',
                    padding: '10px',
                }}
            >
                {selectedTeam ? (
                    <h5>Team bearbeiten</h5>
                ) : (
                    <h5>Neues Team erstellen</h5>
                )}

                {/* Falls Team "Moderator", Name-Feld ausblenden */}
                {selectedTeam && selectedTeam.name.toLowerCase() === 'moderator' ? (
                    <div style={{ marginBottom: '10px' }}>
                        <p>
                            <strong>Moderator-Team</strong>
                        </p>
                    </div>
                ) : (
                    <div style={{ marginBottom: '5px' }}>
                        <label>Teamname:</label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Teamname"
                            value={formData.name}
                            onChange={handleInputChange}
                        />
                    </div>
                )}

                <div style={{ marginBottom: '5px' }}>
                    <label>Punkte:</label>
                    <input
                        type="number"
                        name="punkte"
                        placeholder="Punkte"
                        value={formData.punkte}
                        onChange={handleInputChange}
                    />
                </div>

                {/* Button-Label je nach Modus */}
                {selectedTeam ? (
                    <>
                        <Button size="sm" onClick={handleFormSubmit}>Speichern</Button>
                        {selectedTeam.name.toLowerCase() !== 'moderator' && (
                            <Button
                                size="sm"
                                variant="danger"
                                onClick={handleDelete}
                                style={{ marginLeft: '10px' }}
                            >
                                Löschen
                            </Button>
                        )}
                        <Button size="sm" onClick={resetForm} style={{ marginLeft: '10px' }}>
                            Abbrechen
                        </Button>
                    </>
                ) : (
                    <>
                        <Button size="sm" onClick={handleFormSubmit}>Erstellen</Button>
                    </>
                )}
            </div>
        </div>
    );
}

export default TeamView;